import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SessionProvider, useSession } from "@/context/SessionContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import PortfolioOverview from "@/pages/PortfolioOverview";
import MonthlyReview from "@/pages/MonthlyReview";
import ProjectDetail from "@/pages/ProjectDetail";
import Trends from "@/pages/Trends";
import Import from "@/pages/Import";
import ManagedServicesValue from "@/pages/ManagedServicesValue";
import { Loader2 } from "lucide-react";

function Shell() {
  const { ready, session } = useSession();

  if (!ready || !session) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#faf9f8]" data-testid="app-loading">
        <Loader2 className="animate-spin text-[#0078D4]" size={28} />
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<PortfolioOverview />} />
        <Route path="/trends" element={<Trends />} />
        <Route path="/monthly-review" element={<MonthlyReview />} />
        <Route path="/import" element={<Import />} />
        <Route path="/value" element={<ManagedServicesValue />} />
        <Route path="/projects/:projectId" element={<ProjectDetail />} />
        {/* legacy route redirects */}
        <Route path="/overview" element={<Navigate to="/" replace />} />
        <Route path="/portfolio" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <SessionProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </SessionProvider>
    </div>
  );
}
